module.exports = __webpack_public_path__ + "img/edit.873968b8.svg";